import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["element", "message", "payButton", "spinner"]
  static values = { publishableKey: String, paymentToken: String, amount: String }

  async connect() {
    // Load Stripe.js from CDN if not already loaded
    if (!window.Stripe) {
      await this._loadStripeJs()
    }

    this.stripe = window.Stripe(this.publishableKeyValue)

    // Create payment intent on the server
    try {
      const resp = await fetch(`/pay/${this.paymentTokenValue}/intent`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        }
      })
      const data = await resp.json()

      if (data.error) {
        this._showError(data.error)
        return
      }

      this.clientSecret = data.client_secret

      // Mount Payment Element
      this.elements = this.stripe.elements({
        clientSecret: this.clientSecret,
        appearance: {
          theme: 'night',
          variables: {
            colorPrimary: '#3b82f6',
            colorBackground: '#0a0a0a',
            colorText: '#ffffff',
            colorDanger: '#ef4444',
            fontFamily: 'system-ui, -apple-system, sans-serif',
            borderRadius: '12px',
            spacingUnit: '4px'
          },
          rules: {
            '.Input': { border: '1px solid rgba(255,255,255,0.1)', backgroundColor: 'rgba(255,255,255,0.06)' },
            '.Input:focus': { border: '1px solid rgba(59,130,246,0.5)', boxShadow: 'none' },
            '.Tab': { border: '1px solid rgba(255,255,255,0.1)', backgroundColor: 'rgba(255,255,255,0.04)' },
            '.Tab--selected': { border: '1px solid #3b82f6', backgroundColor: 'rgba(59,130,246,0.1)' },
            '.Label': { color: 'rgba(255,255,255,0.6)' }
          }
        }
      })

      this.paymentElement = this.elements.create('payment', {
        layout: 'tabs',
        defaultValues: {},
        business: { name: 'Motorcoach Club' }
      })
      this.paymentElement.mount(this.elementTarget)

    } catch (err) {
      this._showError("Could not load payment form. Please try again.")
      console.error("Payment init error:", err)
    }
  }

  async pay() {
    if (this.processing) return
    this.processing = true

    this.payButtonTarget.classList.add("hidden")
    this.spinnerTarget.classList.remove("hidden")
    this.messageTarget.classList.add("hidden")

    const { error } = await this.stripe.confirmPayment({
      elements: this.elements,
      confirmParams: {
        return_url: window.location.href
      }
    })

    if (error) {
      this._showError(error.message)
      this.payButtonTarget.classList.remove("hidden")
      this.spinnerTarget.classList.add("hidden")
      this.processing = false
    }
    // If no error, Stripe redirects to return_url
  }

  _showError(msg) {
    this.messageTarget.textContent = msg
    this.messageTarget.classList.remove("hidden")
  }

  _loadStripeJs() {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = 'https://js.stripe.com/v3/'
      script.onload = resolve
      script.onerror = reject
      document.head.appendChild(script)
    })
  }
}
